export default {
  sortBy: {
    id: 'review_display_sort_title',
    defaultMessage: 'Sort by',
  },
  rateAscending: {
    id: 'review_display_sort_rate_ascending',
    defaultMessage: 'Sort by lowest rate',
  },
  rateDescending: {
    id: 'review_display_sort_rate_descending',
    defaultMessage: 'Sort by highest rate',
  },
  recentReviews: {
    id: 'review_display_sort_recent_reviews',
    defaultMessage: 'Sort by most recent reviews',
  },
  relevance: {
    id: 'review_display_sort_relevance',
    defaultMessage: 'Sort by relevance',
  },
}
